import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import StructureIndex from './index';
import LocalESMFoldPage from './esmfold/local';
import ProtenixPage from './protenix';
import ProteinMPNNPage from './proteinmpnn';
import ThermoMPNNPage from './thermompnn';
import HyperMPNNPage from './hypermpnn';
import AntibodyStructurePage from './antibody-denovo';

/**
 * 结构模块的路由配置
 */
export default function StructureRoutes() {
  return (
    <Routes>
      <Route path="/" element={<StructureIndex />} />
      <Route path="/esmfold" element={<LocalESMFoldPage />} />
      <Route path="/protenix" element={<ProtenixPage />} />
      <Route path="/proteinmpnn" element={<ProteinMPNNPage />} />
      <Route path="/thermompnn" element={<ThermoMPNNPage />} />
      <Route path="/hypermpnn" element={<HyperMPNNPage />} />
      <Route path="/antibody" element={<AntibodyStructurePage />} />
    </Routes>
  );
}